import { getNonUmbracoUrl } from "./getNonUmbracoUrl"

/**
 * Resolves the correct URL for a marketing landing page via the CMS url.
 */
export type ResolvedLandingUrl = {
  href: string
  external: boolean
}

export function resolveLandingUrl(
  landing: { url?: string },
  locale: string,
): ResolvedLandingUrl | null {
  const { url } = landing

  if (url) {
    const localePrefix = locale === "he" ? "" : "/en"
    return { href: `${localePrefix}${getNonUmbracoUrl(url)}`, external: false }
  }

  return null
}
